import React, { useState, useEffect, useContext } from "react";
import ephLogo from "../images/eph_logo.png";
import ReCAPTCHA from "react-google-recaptcha";
import LoadingIcon from "../images/Loading_icon.gif";
import { UrlContext } from "../contexts/UrlContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

export default function ApplicationForm({}) {
  const recaptchaRef = React.createRef();
  const [loading, setLoading] = useState(false);
  const invisibleCaptchaKey = "6Lfvkq8pAAAAAJEgk6BDUbP8Aj67IsHdvQaer5yk";
  const [serverCaptcha, setServerCaptcha] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [error, setError] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [completeName, setCompleteName] = useState("");
  const [email, setEmail] = useState("");
  const [linkedinURL, setLinkedinURL] = useState("");
  const [phone, setPhone] = useState("");
  const [type, setType] = useState("Consultant");
  const [fieldsValidation, setFieldsValidation] = useState(false);
  const { API_URL, URI } = useContext(UrlContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (captchaToken) {
      fetch(`${API_URL}check-captcha-validity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ captchaToken, serverCaptcha }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setCaptchaVerified(true);
          } else {
            setCaptchaVerified(false);
          }
        })
        .catch((err) => console.log(err));
    }
    if (!captchaToken) {
      setCaptchaVerified(false);
    }
  }, [captchaToken]);
  useEffect(() => {
    if (!name && !email && phone.length < 8 && !linkedinURL && !isChecked) {
      setError("");
      setFieldsValidation(false);
    } else {
      if (!name || !surname) {
        setError("Name information is missing");
        setFieldsValidation(false);
      } else if (!email || !email.includes("@") || !email.includes(".")) {
        setError("Email information is incomplete or wrong");
        setFieldsValidation(false);
      } else if (phone.length < 8) {
        setError("Phone number is missing");
        setFieldsValidation(false);
      } else if (!linkedinURL.includes("https://www.linkedin.com/in/")) {
        setError(
          "Linkedin URL should start with `https://www.linkedin.com/in/`"
        );
        setFieldsValidation(false);
      } else if (!isChecked) {
        setError("You need to agree with our terms & use");
        setFieldsValidation(false);
      } else {
        setError("");
        setFieldsValidation(true);
      }
    }
  }, [name, surname, email, phone, linkedinURL, isChecked]);
  const submitApplication = () => {
    if (captchaVerified) {
      fetch(`${API_URL}external-user-application`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: completeName,
          email: email.toLowerCase(),
          phone,
          linkedinURL,
          type,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status == "success") {
            window.location.href = "https://www.expertpowerhouse.com/thank-you";
          } else {
            Swal.fire({
              title: "Something went wrong",
              text: `${data.message}`,
              icon: "error",
            });
          }
        });
    } else {
      Swal.fire({
        title: "Error with recaptcha",
        text: "something went wrong, refresh the page",
        icon: "error",
      });
    }
  };

  return (
    <div className="eph-login-body">
      <div className="eph-login-wrapper fadeInDown">
        <div className="eph-login-formContent" style={{ color: "darkgray" }}>
          <div className="fadeIn first">
            <img className="eph-login-logo" src={ephLogo} alt="EPH Logo" />
          </div>
          <span>Apply to become part of our global network.</span>
          <form
            style={{ width: "100%", padding: "25px" }}
            className="my-2"
            onSubmit={(e) => e.preventDefault()}
            onFocus={() => recaptchaRef.current.execute()}
          >
            <div
              className="form-group"
              style={{ display: "flex", flexDirection: "row" }}
            >
              <input
                placeholder="First Name"
                className="form-control mr-1"
                onChange={(e) => {
                  setName(e.target.value);
                  setCompleteName(`${e.target.value} ${surname}`);
                }}
              />
              <input
                placeholder="Last Name"
                className="form-control ml-1"
                onChange={(e) => {
                  setSurname(e.target.value);
                  setCompleteName(`${name} ${e.target.value}`);
                }}
              />
            </div>
            <div className="form-group">
              <input
                placeholder="Email"
                type="email"
                className="form-control"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}

                //   onChange={}
              />
            </div>

            <div className="form-group">
              <PhoneInput
                onChange={(e) => {
                  setPhone(e);
                }}
                value={phone}
                defaultCountry="de"
                inputStyle={{ width: "100%" }}
              />
            </div>
            <div className="form-group">
              <input
                placeholder="Linkedin URL"
                className="form-control"
                onChange={(e) => {
                  setLinkedinURL(e.target.value);
                  // getLinkedinInfo(e.target.value);
                }}
              />
            </div>
            <div className="form-group">
              <label>Please set your desired work modus:</label>
              <select
                className="form-control"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="consultant">
                  Consultant or Interim (available on a full-time or daily
                  basis)
                </option>
                <option value="expert">
                  Expert (available only on an hourly part-time basis)
                </option>
              </select>
            </div>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(!isChecked)}
            />
            <span className="ml-2">
              I agree with EPH{" "}
              <a
                style={{ textDecoration: "none", color: "#37515e" }}
                target="_blank"
                href="https://www.expertpowerhouse.com/privacy-policy"
              >
                Privacy Policy
              </a>{" "}
              {" & "}{" "}
              <a
                style={{ textDecoration: "none", color: "#37515e" }}
                target="_blank"
                href="https://www.expertpowerhouse.com/terms-of-use"
              >
                Terms of use
              </a>
            </span>

            {error ? (
              <div
                className="alert alert-danger mt-2 fadeIn"
                style={{ width: "100%" }}
                role="alert"
              >
                {error}
              </div>
            ) : null}

            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={invisibleCaptchaKey}
              onChange={(value) => {
                setCaptchaToken(value);
                setServerCaptcha("6Lfvkq8pAAAAANBQQAwSyWkRHGYh4D0obJyQrvjo");
              }}
            />
          </form>
          <div className="eph-login-formFooter">
            {!loading ? (
              <button
                style={{
                  backgroundColor: "#37515e",
                  color: "white",
                  width: "100%",
                }}
                type="submit"
                className="btn mt-1"
                disabled={!fieldsValidation}
                onClick={() => submitApplication()}
              >
                Apply
              </button>
            ) : (
              <img
                className="login-loading-icon"
                src={LoadingIcon}
                alt="Loading..."
                style={{ translate: "-20px 20px" }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
